import { useCallback, useState } from 'react';
/** Manages all transient Google Maps UI state as a plain React hook (replaces Vuex). */
export const useMapState = () => {
    const [state, setState] = useState({
        mapMode: 'INITIAL',
        selectedPond: null,
        hoverPond: null,
        drawnCoordinates: null,
        drawnAreaHa: null,
        drawnPlace: null,
    });
    const setMapMode = useCallback((mode) => {
        setState((prev) => ({ ...prev, mapMode: mode }));
    }, []);
    const setSelectedPond = useCallback((pond) => {
        setState((prev) => ({ ...prev, selectedPond: pond }));
    }, []);
    const setHoverPond = useCallback((pond) => {
        setState((prev) => ({ ...prev, hoverPond: pond }));
    }, []);
    const setDrawnPolygon = useCallback((coords, areaHa) => {
        setState((prev) => ({ ...prev, drawnCoordinates: coords, drawnAreaHa: areaHa }));
    }, []);
    const setDrawnPlace = useCallback((place) => {
        setState((prev) => ({ ...prev, drawnPlace: place }));
    }, []);
    const resetDraw = useCallback(() => {
        setState((prev) => ({ ...prev, drawnCoordinates: null, drawnAreaHa: null, drawnPlace: null }));
    }, []);
    return {
        ...state,
        setMapMode,
        setSelectedPond,
        setHoverPond,
        setDrawnPolygon,
        setDrawnPlace,
        resetDraw,
    };
};
